import { isEmpty } from 'lodash';

import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getTemplateTextDisplayLabel, getTemplateTextValue } from './TemplateTextUtils';
import useStyle from './TemplateTextStyle';

const TemplateText = (props) => {
    const {
        openTemplateTextChar,
        closeTemplateTextChar,
        templateTextContextData,
        onRemove,
        decoratedText,
    } = props;

    const classes = useStyle();

    const labelToDisplay = useMemo(() => {
        const templateTextValue = getTemplateTextValue(decoratedText);
        const realValue = templateTextContextData[templateTextValue];

        if (!isEmpty(realValue)) {
            return realValue;
        }

        const templateTextDisplayLabel = getTemplateTextDisplayLabel(decoratedText);

        return `${openTemplateTextChar}${templateTextDisplayLabel}${closeTemplateTextChar}`;
    }, [decoratedText, templateTextContextData, openTemplateTextChar, closeTemplateTextChar]);

    const updatedChildren = React.Children.map(props.children, (child) => React.cloneElement(child, { text: labelToDisplay }));

    return (
        <span className={classes.root} tabIndex={0}>
            {updatedChildren}
            <span className={classes.actions}>
                <FontAwesomeIcon
                    className={classes.icon}
                    icon='times'
                    data-test-id='template-text-remove-button'
                    onFocus={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove(props);
                    }}
                />
            </span>
        </span>
    );
};

TemplateText.defaulProps = {
    templateTextContextData: {},
    onRemove: () => {},
};

TemplateText.propTypes = {
    openTemplateTextChar: PropTypes.string,
    closeTemplateTextChar: PropTypes.string,
    templateTextOptions: PropTypes.array,
    templateTextContextData: PropTypes.object,
    onRemove: PropTypes.func,
    decoratedText: PropTypes.string,
};

export default memo(TemplateText);
